export default __webpack_public_path__ + "static/media/NotoSansKR-Regular.a1ad834e.ttf";